import {
	RECEIVE_BAD_REQUEST_NEW_APPLICATION_FORM_MESSAGE, RECEIVE_NEW_APPLICATION_FORM_MESSAGE,
	REQUEST_NEW_APPLICATION_FORM_MESSAGE
} from "../actions/index";
import {IsJsonString} from "../helpers/functions";

const defaultState = {
	applicationFormMessage: null,
	fetching: false,
	badFetchResponse: ''
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case REQUEST_NEW_APPLICATION_FORM_MESSAGE:
			return {
				...state,
				fetching: true
			};
		case RECEIVE_NEW_APPLICATION_FORM_MESSAGE:
			return {
				...state,
				fetching: false,
				applicationFormMessage: action.payload
			};
		case RECEIVE_BAD_REQUEST_NEW_APPLICATION_FORM_MESSAGE:
			return {
				...state,
				fetching: false,
				badFetchResponse: IsJsonString(action.payload.text)?JSON.parse(action.payload.text): 'Failed to receive new application form messages.'
			};
		default:
			return state
	}
}


